import gql from "graphql-tag"

const fragment = gql`
  fragment fullBusiness on Business {
    uuid
    businessName
    globalAdminRoleId
    globalAdminIds
    isEnabled
    loginPageSsoButtonText
    rootTeamId
    showPasswordLogin
    showSsoLogin
    subdomain
    featureFlags
    metadata {
      createdAt
      createdBy
    }
  }
`

export const toString = fragment.loc.source.body

export default fragment
